import { Typography } from "@material-ui/core";
import * as React from "react";

export const NotFoundPage = () => {

    return (
        <div style={{ margin: "auto", textAlign: "center" }}>
            <Typography variant="h2">404 Cannot find the page you are looking for</Typography>
            <br />
            <br />
            <img src="/images/monkey.jpg" />
        </div>
    );
}